'use client'

import React from 'react'
import { MediaBlock as MediaBlockType } from '@/payload-types'
import { getYouTubeEmbedUrl } from '@/utils/video'
import { trackEvent } from '@/lib/analytics/posthog'

export const VideoMedia: React.FC<MediaBlockType> = (props) => {
  const { youtubeLink, videoFile, videoPoster, videoTitle, copyright } = props

  if (!youtubeLink && !videoFile) return

  return (
    <div className={'w-full'}>
      {videoTitle && (
        <p className={'text-text-base text-headline-M-semibold font-bold mb-8'}>{videoTitle}</p>
      )}
      {videoFile ? (
        // Self-hosted file: preload="none" + poster keeps the page light until someone presses play.
        <video
          src={videoFile}
          poster={videoPoster || undefined}
          controls
          playsInline
          preload="none"
          onPlay={() => trackEvent('videoPlayed', { file: videoFile })}
          className={'w-full aspect-16/9 rounded-md overflow-hidden bg-black'}
        />
      ) : (
        <iframe
          src={getYouTubeEmbedUrl(youtubeLink!)}
          frameBorder="0"
          className={'w-full aspect-16/9 rounded-md overflow-hidden'}
          allow={'accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture; fullscreen'}
          allowFullScreen
        />
      )}
      {copyright && (
        <div
          className={
            '!text-body-XS-regular px-2 mt-2 w-auto flex flex-row items-top justify-between'
          }
        >
          <div></div>
          {copyright && <span className="text-text-faded">© {copyright}</span>}
        </div>
      )}
    </div>
  )
}
